import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import range from 'lodash.range';
import Input from '../Forms/Input';
import SelectField from '../Forms/SelectField';
import styles from './AdditionalInformationFields.css';
import required from '../../utils/fieldRequired';
import SPARTAN_USER_TYPES from '../../../constants/spartan-user-types';

const emptyOption = {
    value: '',
    text: '',
    key: -1,
};


const highSchoolGraduationYears = [emptyOption, {
    value: 2019,
    text: '2019 (Seniors)',
    key: 1,
}, {
    value: 2020,
    text: '2020 (Juniors)',
    key: 2,
}, {
    value: 2021,
    text: '2021 (Sophomores)',
    key: 3,
}, {
    value: 2022,
    text: '2022 (Freshman)',
    key: 4,
}];

const militaryGraduationYears = range(2022, 1979).map(i => ({
    value: i,
    text: i,
    key: i,
}));
militaryGraduationYears.unshift(emptyOption);

const validateMobile = (value) => {
    if (!value || !/^\d{10}$/.test(value)) {
        return 'Please enter valid phone number';
    }
    return undefined;
};

const SpartanAdditionalInformationFields = ({ spartanUserType }) => (<div>
    <div className={styles.row}>
        <Field
            name="mobilePhone"
            label="Mobile Phone"
            component={Input}
            className={styles.input}
            validate={validateMobile}
        />
        <Field
            name="graduationYear"
            label="HS Graduation Year"
            component={SelectField}
            className={styles.input}
            validate={required}
            options={spartanUserType === SPARTAN_USER_TYPES.HIGH_SCHOOL ?
                highSchoolGraduationYears : militaryGraduationYears}
        />
    </div>
    {spartanUserType === SPARTAN_USER_TYPES.HIGH_SCHOOL ? <div className={styles.row}>
        <Field
            name="advisorId"
            label="Advisor ID"
            component={Input}
            className={styles.input}
            validate={required}
        />
        <Field
            name="highSchoolId"
            label="High School ID"
            component={Input}
            className={styles.input}
            validate={required}
        />
    </div> : null}
</div>);

SpartanAdditionalInformationFields.propTypes = {
    spartanUserType: PropTypes.number,
};

export default SpartanAdditionalInformationFields;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/SpartanAdditionalInformationFields.js